import Vue from 'vue';
import object from './request';
// import store from '../store/index';
import qs from 'qs'


// 创建vue实例
let vue = new Vue();
const login = object.loginService; // 带token
const server={
login:{
    //密码登录
    loginByPwd:function (data) {
        return login.post('/auth/crm', data)
    },
}
}
export default server


// WEBPACK FOOTER //
// ./src/axios/api.js